export const addressSelectValidation = {
  streetName: [{ required: true, message: 'Street name is required!' }],
  streetNumber: [{ required: true, message: 'House number is required!' }],
  address: [{ required: true, message: 'Address is required!' }],
  community: [{ required: true, message: 'Community is required!' }],
};
